var _a;
import { pickBy } from 'lodash';
import { exists } from './exists';
var env = {
    apiUrl: process.env.REACT_APP_API_URL,
    stage: process.env.REACT_APP_STAGE,
    stripeClientSecret: process.env.REACT_APP_STRIPE_CLIENT_SECRET,
    versionRef: process.env.REACT_APP_VERSION_REF,
    judoApiKey: process.env.REACT_APP_JUDO_API_KEY,
    socketApiUrl: process.env.REACT_APP_SOCKET_API_URL,
    recaptchaSiteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
};
export var clientConfig = Object.assign((_a = window === null || window === void 0 ? void 0 : window.env) !== null && _a !== void 0 ? _a : {}, pickBy(env, exists));
// get round a caching issue, delete after 2021-11-01
if (!clientConfig.recaptchaSiteKey) {
    clientConfig.recaptchaSiteKey = '6Lc9s4ocAAAAAItPTu-WQ8FQu0C-hDu8ogUvTqRE';
}
//# sourceMappingURL=clientConfig.js.map